import { render, staticRenderFns } from "./serviceChannelManagement.vue?vue&type=template&id=1ca2c658"
import script from "./serviceChannelManagement.vue?vue&type=script&lang=js"
export * from "./serviceChannelManagement.vue?vue&type=script&lang=js"
import style0 from "./serviceChannelManagement.vue?vue&type=style&index=0&id=1ca2c658&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports